// test1358
(1358 && 0);
